<template lang="pug">
#set
  .title
    span 设置
    i.el-icon-close(@click='closeSet')
  .tabnav
    .content
      van-divider(:style="{ color: '#1989fa', borderColor: '#1989fa' }" content-position='left') 环境
      .item.bottom
        span  背景
        van-radio-group(v-model='sBG' direction='horizontal' @change='setBG')
          van-radio(name='-1') 天空盒
          van-radio(name='0') 深色
          van-radio(name='1') 浅色
    .content
      van-divider(:style="{ color: '#1989fa', borderColor: '#1989fa' }" content-position='left') 漫游
      .item
        span  速度
        van-stepper(v-model='walkOption.speed' step='0.1' min='0' max='10' @change='changeSpeed')
      .item
        span  旋转速度
        van-stepper(v-model='walkOption.rotateSpeed' step='0.1' min='0' max='10' @change='changeRotateSpeed')
      .item
        span  固定z轴
        van-switch(v-model='walkOption.fixedZAxis' size='20px' @change='changefixedZAxis')
      .item
        span  碰撞检测
        van-switch(v-model='walkOption.collide' size='20px' @change='changeCollide')
      .item.bottom
        span  重力
        van-switch(v-model='walkOption.gravity' size='20px' @change='changeGravity')
    .content
      van-divider(:style="{ color: '#1989fa', borderColor: '#1989fa' }" content-position='left') 渲染
      .item
        span  模型边线
        van-switch(v-model='effectOption3D.fouLine' size='20px' @change='changeFouLine')
      .item
        span  环境光遮蔽
        van-switch(v-model='effectOption3D.ssao' size='20px' @change='changeSsao')
      .item
        span  阴影
        van-switch(v-model='effectOption3D.shadow' size='20px' @change='changeShadow')
      .item
        span  曝光自适应
        van-switch(v-model='effectOption3D.automaticExposure' size='20px' @change='changeAutomaticExposure')
      .item
        span  亮度
        van-stepper(v-model='effectOption3D.intensity' step='1' min='0' max='100' @change='changeIntensity')
      .item
        span  饱和度
        van-stepper(v-model='effectOption3D.saturation' step='1' min='0' max='100' @change='changeSaturation')
      .item.bottom
        span  色温
        van-radio-group(v-model='effectOption3D.temperature' direction='horizontal' @change='changeTemperature')
          van-radio(v-for="(item,index) in curTemperatureList" :key="index" :name='item.value') {{item.name}}

</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";

export default {
  data () {
    return {
      setBoolean: false,
      setList: ["漫游", "轮廓", "渲染", "环境"],
      active: "漫游",
      walkOption: {},
      effectOption3D: {},

      gravity: false,
      collision: false,
      outlineCpu: false,
      outlineGpu: false,
      outlineFxaa: false,
      envSsao: false,
      speed: 0,
      single: "0",
      piexl: "",
      frameval: 0,
      sBG: "",
      temperature: "0",
      hard: 0,
      settingData: []
    };
  },
  computed: {
    curTemperatureList() {
      return mongeApiMlib.curTemperatureList();
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      const { x, y, z } = mongeApiMlib.get3DBgc();
      if (x === -1 && y === -1 && z === -1) {
        this.sBG = "-1";
      } else if (x === 33 && y === 40 && z === 48) {
        this.sBG = "0";
      } else if (x === 240 && y === 240 && z === 240) {
        this.sBG = "1";
      }
      mongeMutations.changeShowApp(false);
      this.walkOption = { ...mongeApiMlib.walkOption3D() };
      this.effectOption3D = { ...mongeApiMlib.effectOption3D() };
    },
    closeSet() {
      mongeMutations.changeShowApp(true);
      this.$emit("closeCom", 'set', false);
    },
    // 背景色
    setBG() {
      if (this.sBG == "-1") {
        mongeApiMlib.set3DBgc([-1, -1, -1]);
      } else if (this.sBG == "0") {
        mongeApiMlib.set3DBgc([33, 40, 48]);
      } else if (this.sBG == "1") {
        mongeApiMlib.set3DBgc([240, 240, 240]);
      }
    },
    // 速度修改
    changeSpeed(val) {
      mongeApiMlib.changeSpeed(val);
    },
    // 旋转速度修改
    changeRotateSpeed(val) {
      mongeApiMlib.changeRotateSpeed(val);
    },
    // 固定Z轴
    changefixedZAxis(val) {
      mongeApiMlib.changefixedZAxis(val);
    },
    // 碰撞检测
    changeCollide(val) {
      mongeApiMlib.changeCollide(val);
    },
    // 重力
    changeGravity(val) {
      mongeApiMlib.changeGravity(val);
    },
    // 模型边线
    changeFouLine(val) {
      mongeApiMlib.changeFouLine(val);
    },
    // 环境光遮蔽
    changeSsao(val) {
      mongeApiMlib.changeSsao(val);
    },
    // 阴影
    changeShadow(val) {
      mongeApiMlib.changeShadow(val);
    },
    // 曝光自适应
    changeAutomaticExposure(val) {
      mongeApiMlib.changeAutomaticExposure(val);
    },
    // 亮度
    changeIntensity(val) {
      mongeApiMlib.changeIntensity(val);
    },
    // 饱和度
    changeSaturation(val) {
      mongeApiMlib.changeSaturation(val);
    },
    // 色温
    changeTemperature(val) {
      mongeApiMlib.changeTemperature(val);
    }
  }
};
</script>

<style lang="scss" scoped>
#set{
  position: fixed;
  bottom: 0;
  left: 0;
  top: 44px;
  width: 290px;
  height: calc(100% - 44px);
  overflow: hidden;
  z-index: 4;
  background: rgba(255, 255, 255, 0.95);
  .title{
    width: 100%;
    height: 40px;
    padding: 0 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #E5E8F1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    span{
      font-size: 17px;
      font-weight: 700;
    }
    i{
      font-size: 16px;
    }
  }
  .tabnav{
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 10px 5px 0;
  }
  .tabnav::-webkit-scrollbar{width: 0 !important;}
  .tabnav{-ms-overflow-style: none;}
  .tabnav{overflow: -moz-scrollbars-none;}
  .content{
    width: 100%;
    display: flex;
    flex-direction: column;
    .van-divider{
      margin: 0;
    }
    .item{
      width: 100%;
      height: 44px;
      box-sizing: border-box;
      padding: 0 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
    }
    .bottom{
      border: 0;
    }
  }
}
</style>
